import React, { useState,useEffect } from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import InvoicePreviewLayer from "../components/InvoicePreviewLayer";
import { useParams } from "react-router-dom";
import { API_URL } from "..";
import { Spinner } from "react-bootstrap";




const InvoicePreviewPage = () => {
     const {id} = useParams();
     const [data,setData]= useState({})
     const [isLoading,setIsLoading ]= useState(false)
    
      const fetchSingle = async ()=>{
      //  alert(';Please')
      setIsLoading(true)
        const user = JSON.parse(localStorage.getItem('user'));
         
       let headersList = {
         "Accept": "*/*",
         "Content-Type": "application/json"
        }
        
        let response = await fetch(`${API_URL}/api/invoice/${user.id}/${id}`, { 
          method: "GET",
          headers: headersList
        });
        const data = await response.json();
        setIsLoading(false)
        setData(data)
      }
        useEffect(()=>{
          fetchSingle()
          },[2])
  return (
    <>

      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb title="Invoice - Preview" />

        {/* InvoicePreviewLayer */}
        {isLoading && (
    <div style={{
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.8)',
        zIndex: 9000,
        borderRadius: '12px'
    }}>
        <Spinner
            animation="border" 
            role="status"
            variant="info"
            style={{ width: '3rem', height: '3rem' }}
        >
            <span className="visually-hidden">Loading...</span>
        </Spinner>
    </div>
)}
      
      {
        data?.invoice_number  === undefined && isLoading === true ? 
        null:
          <InvoicePreviewLayer data={data} />
      }
      

      </MasterLayout>

    </>
  );
};

export default InvoicePreviewPage;
